import React, { useState, useEffect, useContext } from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Alert,
  Button,
  Badge,
  Modal,
  Form,
  Spinner,
  DropdownItem,
} from "reactstrap";
import {
  Block,
  PreviewCard,
  Icon,
  PaginationComponent,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  DataTableBody,
} from "../../components/Component";
import { paymentHistory, paymentWithdrawAmt, userPayStatus } from "../../app/api";
import { Link } from "react-router-dom";
import Loader from "../../app/Loader";
import Moment from "react-moment";
import AppContext from "../../context/AppContext";
import { ToastContainer, toast } from "react-toastify";

export default function Wallet() {
  const ctx = useContext(AppContext);
  const [loading, setLoading] = useState(true);

  const [kycSts, setKycSts] = useState(8);
  const [paySts, setPaySts] = useState(1);
  const [payData, setPayData] = useState(null);
  const [upComingPay, setUpComingPay] = useState(null);
  const [getpayoutMode, setpayoutMode] = useState(null);
  const [getAvalableAmt, setAvalableAmt] = useState(null);

  // const [tdate, setTdate] = useState(null);
  const [tdate] = useState(null);
  const apc = useContext(AppContext);
  const [wlog, setWlog] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [pgs, setPgs] = useState(0);
  const [isEligible, setIsEligible] = useState(false);

  const payStatus = async () => {
    setLoading(true);
    const uid = localStorage.getItem("uid");
    const res = await userPayStatus({ uid: uid });
    
    // const available = Number(res.data.avalable_amt.replace(/,/g, ''));
    const available = Number(String(res.data.avalable_amt).replace(/,/g, ''));
    const limit = Number(res.data.withdrawl_limit);
    if (available > limit && res?.data?.payout_mode) {
      setIsEligible(true);
    }
    setKycSts(res.data.kyc_status);
    setPaySts(res.data.pay_mode_status);
    setPayData(res.data);
    setUpComingPay(res.data.upcoming_pay_list);
    setpayoutMode(res.data.payout_mode);
    setAvalableAmt(res.data.avalable_amt);

    if (res.data) {
      apc.dispatch({
        type: "wlt",
        wlt: res.data.avalable_amt,
      });
    }
    setLoading(false);
  };

  const getPaymentLog = async (pg = 1) => {
    setLoading(true);
    let uid = localStorage.getItem("uid");
    let res = await paymentHistory({
      uid: uid,
      page: pg,
      lim: itemPerPage,
    });
    if (res) {
      setWlog(res.data);
      setPgs(res.row);
    }
    setLoading(false);
  };
//---------------------------------------------------------------//
  
  const [save, setSave] = useState(false);

  const [composeModal, setComposeModal] = useState(false);
  const toggleModal = () => {
     setComposeModal(!composeModal);
     setErrors('');
     setSave(false);
   };
  

  const [errors, setErrors] = useState('');
  const [amount, setAmount] = useState('');
  const handleSubjectChange = (e) => {
      const value = e.target.value;
      const pubAmount = getAvalableAmt;
      const num = parseFloat(String(pubAmount).replace(/,/g, ''));
      // const num = parseFloat(pubAmount.replace(/,/g, ''));
      if (/^(0|[1-9]\d{0,4})$/.test(value)) {
        if (value.toLocaleString() <= num) {
          setAmount(value);
          setErrors('');
        } else {
          setAmount(value);
          setErrors('Your available balance is ' + pubAmount + '.');
        }
      } else {
        setErrors('Please enter only numbers.');
      }
    };
    const submitForm = async (e) => {
      e.preventDefault();
      setSave(true);
      let user_id = localStorage.getItem("uid");
      let withdrawal_amount = amount;
      // const AvalableAmt = Number(getAvalableAmt.replace(/,/g, ''));
      const AvalableAmt = Number(String(getAvalableAmt).replace(/,/g, ''));
      const requertAmount = Number(amount);
      if(AvalableAmt < withdrawal_amount || withdrawal_amount === 0){
        let msgss;
        if (withdrawal_amount === 0) {
          msgss = 'Please enter a valid amount.';
        } else {
          msgss = `Please enter a valid amount. Avilable ${AvalableAmt}`;
        }
        toast.error(msgss, {
          position: "top-right",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: false,
        });
        setErrors(msgss);
        setSave(false);
        return;
      }
      if (!amount) {
        setErrors('Amount is required.');
        setSave(false);
      } else if (parseInt(amount) > 99999) {
        setErrors('Maximum value is 99999.');
        setSave(false);
      }else if (AvalableAmt < requertAmount) {
        setErrors('You are not eligible for withdrawal, please contact support.');
        setSave(false);
      } else {
        const res = await paymentWithdrawAmt(user_id,withdrawal_amount,getpayoutMode);
        setSave(true);
        if (res.code === 200) {
          toast.success(res.message, {
              position: "top-right",
              autoClose: true,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: false,
            });
          setSave(false);   
          payStatus(); 
          setComposeModal(false);
        }else{
          setErrors(res.message);
          setSave(false);
        }
      }

     
    };
  
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (currentPage !== pageNumber) {
      getPaymentLog(pageNumber);
    }
  };
  const utype = localStorage.getItem("utype");

  useEffect(() => {
    if (utype === 1) {
    }
    getPaymentLog(1);
    payStatus();
  }, [itemPerPage]);

  return (
    <React.Fragment>
      <Head title="My Wallet" />

      {utype === 1 ? (
        <Content page="component">
          <Block size="lg" className="pt-5">
            <PreviewCard>
              <Row className="gy-4">
                <Col sm="12">
                  <div className="card-amount">
                    <span
                      className="amount text-primary mb-3"
                      style={{ fontSize: 18 }}
                    ></span>
                  </div>
                  <div className="card-title text-center">
                    <h2>404 </h2>
                    <h5 className="titel">Page Not Found</h5>
                  </div>
                </Col>
              </Row>
            </PreviewCard>
          </Block>
        </Content>
      ) : (
        <Content page="component">
          <Block size="lg">
            <Loader visible={loading} />
            {kycSts === 0 && (
              <Alert className="alert-icon alert-fill" color="danger">
                <Icon name="alert" />
                You have not uploaded your documents for the KYC.{" "}
                <Link to="user-kyc" className="alert-link">
                  Click Here
                </Link>{" "}
                to upload your documents.
              </Alert>
            )}
            {kycSts === 1 && (
              <Alert className="alert-icon alert-fill" color="dark">
                <Icon name="alert" />
                Thank you for your KYC submission. Your details are under
                review, and we'll notify you once the process is complete.
              </Alert>
            )}
            {kycSts === 3 && (
              <Alert className="alert-icon alert-fill" color="danger">
                <Icon name="alert" />
                Your KYC submission has been rejected. Kindly review the reason
                for rejection and re-upload the necessary documents.
              </Alert>
            )}
            {paySts === 0 && (
              <Alert className="alert-icon alert-fill" color="info">
                <Icon name="alert" />
                You have not set any payment method.{" "}
                <Link to="user-payment-method" className="alert-link">
                  Click Here
                </Link>{" "}
                to update payment method.
              </Alert>
            )}

            <PreviewCard>
              <Row className="gy-4">
                <Col sm="12">
                  <div className="card-amount">
                    <span
                      className="amount text-primary mb-3"
                      style={{ fontSize: 18 }}
                    >
                      {/* Payment Rule */}
                      Payout Rule
                    </span>
                  </div>
                  <div className="card-title">
                    <div className="subtitle text-dark">
                      {/* Payment dates are the{" "} */}
                      Payout dates are the{" "}
                      <b>
                        1<sup>st</sup> and 15<sup>th</sup>
                      </b>{" "}
                      of each month, from 9.00 AM till 6.00 PM IST. If these dates fall on weekends or holidays, the payments will be processed on the nearest business day. Once you reach the minimum payout amount, you can request a withdrawal. You will get the payout during the first payment period available after your withdrawal request.
                    </div>
                  </div>
                  <div className="invest-data">
                    <div className="invest-data-amount g-2">
                      <div className="invest-data-history">
                        <div className="card-title">
                          <div className="subtitle">
                            {tdate !== null && (
                              <span>
                                <Icon
                                  name="calendar-fill"
                                  style={{
                                    fontSize: "16px",
                                    marginTop: "15px",
                                  }}
                                />{" "}
                                Your last payment was on {tdate}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </PreviewCard>
          </Block>
          {ctx.sts.perms.includes("432") || ctx.sts.perms.includes("9999") ? (
            <Block size="lg" className="pt-5">
              <PreviewCard>
                <Row className="gy-4">
                  <Col sm="12">
                    <div className="card-amount">
                      <span
                        className="amount text-primary mb-3"
                        style={{ fontSize: 18 }}
                      >
                        {/* Payment Details */}
                        Payout Details
                      </span>
                    </div>
                    <div className="card-title">
                      <div
                        className="amount text-dark"
                        style={{ fontSize: 16 }}
                      >
                        <span className="mr-5">Total Earnings </span>
                        <span className="ml-5">
                          ${payData ? payData.total_earning : 0}
                        </span>
                      </div>
                      <div
                        className="amount text-dark"
                        style={{ fontSize: 16 }}
                      >
                        <span className="mr-4">Total Withdrawal </span>
                        <span className="ml-5">
                          {" "}
                          &nbsp;${payData ? payData.total_withdrawl : 0}
                        </span>
                      </div>
                      <div
                        className="amount text-dark fw-bold mt-2 "
                        style={{ fontSize: 16 }}
                      > 
                        <span className="mr-3">Available Balance</span>
                        <span className="ml-5">
                          &nbsp; ${payData ? payData.avalable_amt : 0}
                        </span>
                        <span> 
                          {(!isEligible) ? 
                           <button className="btn btn-primary btn-sm float-right mr-3" style={{ float: 'right', cursor: "not-allowed", }} disabled={!isEligible} title="Withdrawal amount not reached.">
                           Request Withdrawal
                         </button>:
                          <button className="btn btn-primary btn-sm float-right mr-3" style={{ float: 'right' }} onClick={() =>  setComposeModal(true)}>
                          Request Withdrawal
                        </button>
                        }
                         
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </PreviewCard>
            </Block>
          ) : (
            ""
          )}
          {ctx.sts.perms.includes("434") || ctx.sts.perms.includes("9999") ? (
            <Block size="lg" className="pt-5">
              <Row className="gy-4">
                <Col sm="12">
                  <PreviewCard>
                    <div className="card-inner-group">
                      <div className="card-inner">
                        <div className="card-title-group">
                          <div className="card-title">
                            {/* <h5 className="title">Upcoming Payments</h5> */}
                            <h5 className="title">Upcoming Payouts</h5>
                            <div className="subtitle">
                              {/* <span>Last 10 payment record</span> */}
                            </div>
                          </div>
                          <div className="card-tools mr-n1"></div>
                        </div>
                      </div>
                      <div className="mb-3 table-responsive">
                        <DataTableBody
                          className="border-top"
                          bodyclass="nk-tb-orders pr-0 pl-0"
                        >
                          <DataTableHead bgColor="#fff">
                            <DataTableRow>
                              <span>
                                <b>Release Date</b>
                              </span>
                            </DataTableRow>
                            <DataTableRow>
                              <span>
                                {" "}
                                <b>Transaction ID</b>
                              </span>
                            </DataTableRow>
                            <DataTableRow>
                              <span>
                                {" "}
                                <b>Amount</b>
                              </span>
                            </DataTableRow>
                            <DataTableRow className="text-right">
                              <span>
                                <b>Status</b>
                              </span>
                            </DataTableRow>
                          </DataTableHead>
                          {upComingPay &&
                            upComingPay.map((item, key) => {
                              return (
                                <DataTableItem>
                                  <DataTableRow>
                                    <span className="tb-sub text-muted">
                                      {item.release_date}
                                    </span>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <span className="text-muted">
                                      {item.transaction_id}{" "}
                                    </span>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <span className="tb-sub text-muted">
                                      {" "}
                                      ${item.amount.toFixed(2)}{" "}
                                    </span>
                                  </DataTableRow>
                                  <DataTableRow className="text-right">
                                    <span className="tb-sub tb-amount">
                                      <span>
                                        {item.status === 0 ? (
                                          <Badge
                                            color="info"
                                            className="text-light"
                                          >
                                            Process
                                          </Badge>
                                        ) : (
                                          <Badge
                                            color="warning"
                                            className="text-dark"
                                          >
                                            Hold
                                          </Badge>
                                        )}
                                      </span>
                                    </span>
                                  </DataTableRow>
                                </DataTableItem>
                              );
                            })}
                        </DataTableBody>
                      </div>
                    </div>
                  </PreviewCard>
                </Col>
              </Row>
            </Block>
          ) : (
            ""
          )}
            <Modal
              isOpen={composeModal}
              className="modal-sl"
              toggle={() => toggleModal()}
              backdrop="static" 
              keyboard={false}
            >
              <div className="modal-header">
                <h6 className="modal-title">Withdrawal Amount</h6>
                <a
                  href="#cancel"
                  onClick={(ev) => {
                    ev.preventDefault();
                    toggleModal();
                  }}
                  className="close"
                >
                  <Icon name="cross-sm"></Icon>
                </a>
              </div>
              <Form onSubmit={submitForm}>
                <div className="modal-body p-4">
                  <div className="nk-reply-form-editor pl-4 pr-4 pb-4">
                    <div className=" mb-2">
                      <div className="mt-1">
                      </div>
                    </div>

                    <div className="nk-reply-form-editor">
                      <div className="nk-reply-form-field custom-border">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="\d*"
                          maxLength={5}
                          className="form-control form-control-simple h-25"
                          placeholder="Enter Amount"
                          name="subject"
                          onChange={handleSubjectChange}
                        />
                      </div>
                      {errors && (
                        <span className="text-danger">{errors}</span>
                      )}
                    </div>

                    <div className="mt-2" style={{ float: 'right' }}>
                      <div className=" mt-2">
                        <ul className="nk-reply-form-actions g-1">
                          <li className="ml-2">
                            <Button color="primary" type="submit">
                              {save ? (
                                <span>
                                  <Spinner size="sm" /> &nbsp;Processing..
                                </span>
                              ) : (
                                <span> Submit </span>
                              )}
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </div><br></br><br></br>
                  </div>
                </div>
              </Form>
            </Modal>
            {ctx.sts.perms.includes("436") || ctx.sts.perms.includes("9999") ? (
              <Block size="lg" className="pt-5">
                <PreviewCard>
                  <Row className="gy-4">
                    <Col sm="12">
                      <div className="card-amount">
                        <span
                          className="amount text-primary mb-3"
                          style={{ fontSize: 18 }}
                        >
                          {/* Current Payment Method */}
                          Current Payout Method
                        </span>
                      </div>
                      <div className="card-title">
                        <div
                          className="amount text-dark"
                          style={{ fontSize: 16 }}
                        >
                          {payData && payData.payout_mode.length > 0 ? (
                            <h6 className="title">
                              <img
                                src={payData.image}
                                alt="sign-paypal-alt"
                                style={{
                                  maxWidth: "100%",
                                  height: "auto",
                                  width: "27px",
                                  maxHeight: "27px",
                                }}
                              />{" "}
                              &nbsp; {payData.display_name}
                              {/* <Badge color="light">Default</Badge> */}
                              <Link
                                to="user-payment-method"
                                className="btn btn-sm btn-primary float-right"
                              >
                                Change
                              </Link>
                            </h6>
                          ) : (
                            "No Payment Method Selected"
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </PreviewCard>
              </Block>
            ) : (
              ""
          )}
          {ctx.sts.perms.includes("438") || ctx.sts.perms.includes("9999") ? (
            <Block size="lg" className="pt-5">
              <Row className="gy-4">
                <Col sm="12">
                  <PreviewCard>
                    <div className="card-inner-group">
                      <div className="card-inner">
                        <div className="card-title-group">
                          <div className="card-title">
                            <h5 className="title">Transaction History</h5>
                            <div className="subtitle">
                              {/* <span>Last 10 payment record</span> */}
                            </div>
                          </div>
                          <div className="card-tools mr-n1"></div>
                        </div>
                      </div>
                      <div className="card-inner p-0 table-responsive">
                        <table className="table table-tranx">
                          <thead>
                            <tr
                              style={{ background: "#3b82f6", color: "#fff" }}
                            >
                              <th>
                                <span>Transaction Date</span>
                              </th>
                              <th>Transaction ID</th>
                              {/* <th>Payment Mode</th> */}
                              <th>Payout Mode</th>
                              <th>Paid Amount</th>
                              <th className="text-right">Status</th>
                              <th>
                                <span>Action</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {wlog != null
                              ? wlog.map((item) => {
                                  return (
                                    <tr key={item.id}>
                                      <td className="tb-tnx-info">
                                        <Moment format="DD MMM YYYY">
                                          {item.release_created_at
                                            ? item.release_created_at
                                            : item.release_date}
                                        </Moment>
                                      </td>
                                      <td className="text-muted">
                                        {" "}
                                        {item.transaction_id}{" "}
                                      </td>
                                      <td className="text-muted">
                                        {item.payout_method}
                                      </td>
                                      <td className="fw-bold">
                                        ${item.amount.toFixed(2)}
                                      </td>
                                      <td className="text-right">
                                        <span
                                          className={`badge badge-dot badge-${
                                            item.status === 1
                                              ? "success"
                                              : item.status === 2
                                              ? "danger"
                                              : "warning"
                                          }`}
                                        >
                                          {item.status === 1
                                            ? "COMPLETED"
                                            : item.status === 2
                                            ? "FAILED"
                                            : "PENDING"}
                                        </span>
                                      </td>
                                      <td className="text-dark">
                                        <UncontrolledDropdown>
                                          <DropdownToggle
                                            tag="a"
                                            className="text-soft dropdown-toggle btn btn-icon btn-trigger"
                                          >
                                            <Icon name="more-h"></Icon>
                                          </DropdownToggle>
                                          <DropdownMenu right>
                                            <ul className="link-list-plain">
                                              <li>
                                                {item.invoice_number !== 0 ? (
                                                  <Link
                                                    to={`${
                                                      process.env.PUBLIC_URL
                                                    }/payout-invoice-view/${btoa(
                                                      item.transaction_id
                                                    )}`}
                                                  >
                                                    <Icon name="eye"></Icon>{" "}
                                                    View
                                                  </Link>
                                                ) : (
                                                  <Link
                                                    style={{
                                                      cursor: "not-allowed",
                                                    }}
                                                  >
                                                    <Icon name="eye"></Icon>{" "}
                                                    View
                                                  </Link>
                                                )}
                                              </li>
                                              <li>
                                                {item.invoice_number !== 0 ? (
                                                  <Link
                                                    to={`${
                                                      process.env.PUBLIC_URL
                                                    }/payout-invoice-print/${btoa(
                                                      item.transaction_id
                                                    )}`}
                                                    target="_blank"
                                                  >
                                                    <Icon name="printer-fill"></Icon>{" "}
                                                    <span>Print</span>
                                                  </Link>
                                                ) : (
                                                  <Link
                                                    style={{
                                                      cursor: "not-allowed",
                                                    }}
                                                  >
                                                    <Icon name="printer-fill"></Icon>{" "}
                                                    Print
                                                  </Link>
                                                )}
                                              </li>
                                            </ul>
                                          </DropdownMenu>
                                        </UncontrolledDropdown>
                                      </td>
                                    </tr>
                                  );
                                })
                              : null}
                          </tbody>
                        </table>
                        <div className="card-inner" style={{ display: "flex" }}>
                          <div
                            style={{ alignSelf: "self-start", width: "97%" }}
                          >
                            {wlog && wlog.length ? (
                              <PaginationComponent
                                itemPerPage={itemPerPage}
                                totalItems={pgs}
                                paginate={paginate}
                                currentPage={currentPage}
                              />
                            ) : (
                              <div className="text-center">
                                
                                <span className="text-silent">
                                  No transaction found
                                </span>
                              </div>
                            )}
                          </div>
                          <div>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle bg-white btn btn-sm btn-outline-light btn-icon"
                              >
                                &nbsp; &nbsp; {itemPerPage} <Icon name="downward-ios"></Icon>
                              </DropdownToggle>
                              <DropdownMenu right>
                                <ul className="link-list-opt no-bdr">
                                  <li onClick={() => {}}>
                                    <DropdownItem
                                      tag="a"
                                      href="#"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setItemPerPage(10);
                                      }}
                                    >
                                      <span>10</span>
                                    </DropdownItem>
                                  </li>
                                  <li onClick={() => {}}>
                                    <DropdownItem
                                      tag="a"
                                      href="#"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setItemPerPage(20);
                                      }}
                                    >
                                      <span>20</span>
                                    </DropdownItem>
                                  </li>
                                  <li onClick={() => {}}>
                                    <DropdownItem
                                      tag="a"
                                      href="#"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setItemPerPage(50);
                                      }}
                                    >
                                      <span>50</span>
                                    </DropdownItem>
                                  </li>
                                  <li onClick={() => {}}>
                                    <DropdownItem
                                      tag="a"
                                      href="#"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setItemPerPage(100);
                                      }}
                                    >
                                      <span>100</span>
                                    </DropdownItem>
                                  </li>
                                  <li onClick={() => {}}>
                                    <DropdownItem
                                      tag="a"
                                      href="#"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setItemPerPage(500);
                                      }}
                                    >
                                      <span>500</span>
                                    </DropdownItem>
                                  </li>
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PreviewCard>

                  {/* <Card className="card-bordered">
                    <CardHeader className="border-bottom"></CardHeader>
                    <CardBody className="card-inner">
                    <table className="table table-borderless">  
                     
                        <tbody>   
                          {wlog !== null ? 
                            wlog.map((item)=>{
                             return <tr>          
                                  <td>{item.date}</td>      
                                  <td className="text-right">${item.amount}</td>      
                              </tr>  
                            })  
                            : '' }
                           
                        </tbody>
                    </table>

                    </CardBody>
                  </Card> */}
                  {/* <PreviewCard>
                    </PreviewCard> */}
                </Col>
              </Row>
            </Block>
          ) : (
            ""
          )}
        </Content>
      )}
      <ToastContainer />
    </React.Fragment>
  );
}
